module.exports = __webpack_public_path__ + "img/box5.ddb50cc6.png";